import LandingNavbar from './components/LandingNavbar';
import HeroSection from './components/HeroSection';
import BentoSection from './components/BentoSection';
import StackedSection from './components/StackedSection';
import StatsBand from './components/StatsBand';
import SegmentsSection from './components/SegmentsSection';
import PrizesCatalog from './components/PrizesCatalog';
import SupportJourneySection from './components/SupportJourneySection';
import CasesCarousel from './components/CasesCarousel';
import FaqSection from './components/FaqSection';
import LandingFooter from './components/LandingFooter';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <LandingNavbar />
      <main>
        <HeroSection />
        <BentoSection />
        <StackedSection />
        <StatsBand />
        <SegmentsSection />
        <PrizesCatalog />
        <SupportJourneySection />
        <CasesCarousel />
        <FaqSection />
      </main>
      <LandingFooter />
    </div>
  );
}